/* Item Edit, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="item-edit" class="entity-edit">
      <v-card-title>Edit Item</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-alert
          v-if="serverErrorMessage"
          type="error"
        >
          {{ serverErrorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>
        <v-btn
          color="primary"
          class="me-3"
          @click="Save"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiContentSaveOutline  }}
          </v-icon>
          <span>Save</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          @click="Back"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiChevronLeft }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-form ref="form">
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>


      <tr>
        <td>Order</td>
        <td><OrderLookup v-model="entity.OrderId" :rules="[validators.requiredInteger]" :error-messages="serverErrors.filter(x => x.field === 'OrderId').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Length</td>
        <td><v-text-field
      label="Length"
      solo-inverted
			type="number"
      flat
      suffix="mm"
      :error-messages="serverErrors.filter(x => x.field === 'Length').map(x => x.error)"
      v-model="entity.Length"
      :rules="[validators.requiredInteger,validators.positiveIntegerValidator,validators.integerRange(entity.Length, 0, 10000)]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Width</td>
        <td><v-text-field
      label="Width"
      solo-inverted
			type="number"
      flat
      suffix="mm"
      :error-messages="serverErrors.filter(x => x.field === 'Width').map(x => x.error)"
      v-model="entity.Width"
      :rules="[validators.requiredInteger,validators.positiveIntegerValidator,validators.integerRange(entity.Width, 0, 10000)]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Height</td>
        <td><v-text-field
      label="Height"
      solo-inverted
			type="number"
      flat
      suffix="mm"
      :error-messages="serverErrors.filter(x => x.field === 'Height').map(x => x.error)"
      v-model="entity.Height"
      :rules="[validators.requiredInteger,validators.positiveIntegerValidator,validators.integerRange(entity.Height, 0, 10000)]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Damaged</td>
        <td><v-checkbox v-model="entity.Damaged" :color="(entity.Damaged ? 'success' : 'secondary')"></v-checkbox></td>
      </tr>

      <tr>
        <td>Refused Delivery</td>
        <td><v-checkbox v-model="entity.RefusedDelivery" :color="(entity.RefusedDelivery ? 'success' : 'secondary')"></v-checkbox></td>
      </tr>

      <tr>
        <td>Do Not Send</td>
        <td><v-checkbox v-model="entity.DoNotSend" :color="(entity.DoNotSend ? 'success' : 'secondary')"></v-checkbox></td>
      </tr>

      <tr>
        <td>Notes</td>
        <td><v-text-field
      label="Notes"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Notes').map(x => x.error)"
      v-model="entity.Notes"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>User</td>
        <td><UserLookup v-model="entity.BookedInBy" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'BookedInBy').map(x => x.error)" /></td>
      </tr>


        </tbody>
      </v-simple-table>
      </v-form>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'
import * as FrameworkValidators from '@core/utils/validation'
import * as Validators from '@/datahelpers/validation'

import OrderLookup from '@/views/order/OrderLookup'
import UserLookup from '@/views/user/UserLookup'

import {
  mdiContentSaveOutline,
  mdiChevronLeft
} from '@mdi/js'
import { ref, watch, computed, expose } from '@vue/composition-api'

export default {
  components: {

    OrderLookup,
		UserLookup
  },
  setup() {

    const { route, router  } = useRouter();

    const entity = computed(() => {
      return store.state.app.Item;
    });
    const loading = ref(false);
    const form = ref(null);
    const serverErrors = ref([]);
    const serverErrorMessage = ref(null);

    const fetchData = (id) => {
      store
        .dispatch('app/fetchItem', {
          id: id
        })
        .then(response => {
          loading.value = false;
        })
        .catch(error => {
          loading.value = false;
          console.log(error);
          router.push({ name: 'item-list', params: { id: route.value.params.id } });
        })
    }

    // fetch the user information when params change
    watch(() => route.value.params.id, (id) => fetchData(id));

    // and call now
    fetchData(route.value.params.id);


    const Save = function(e) {

      serverErrorMessage.value = null;
      serverErrors.value = [];

      const valid = form.value.validate();

      if (!valid) {
        return;
      }

      loading.value = true;

      store
        .dispatch('app/updateItem', {
          id: route.value.params.id,
          entity: entity.value
        })
        .then(response => {
          loading.value = false;
          router.push({ name: 'item-view', params: { id: response.data.Id } });
        })
        .catch((error) => {
          loading.value = false;
          if (error.error) {
            if (error.message) serverErrorMessage.value = error.message;
            if (error.errors) serverErrors.value = error.errors
          } else {
            console.log(error);
          }
        });
    };

    const Back = () => {
      router.go(-1);
    };

    const validators = {
      ...FrameworkValidators,
      ...Validators
    };

    return {
      Back,
      form,
      Save,
      loading,
      entity,
      Display,
      icons: {
        mdiContentSaveOutline ,
        mdiChevronLeft
      },
      validators,
      serverErrorMessage,
      serverErrors
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-edit::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  padding-right: 0;
}
.entity-edit::v-deep .v-data-table th:last-child {
  width: 66%;
}
.entity-edit::v-deep  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-messages {
  min-height: unset;
}
.entity-edit::v-deep .v-input .v-messages.error--text {
  margin-bottom: 8px;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-text-field__details {
  min-height: unset;
  margin-bottom: 0;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-input__slot {
  margin: 0;
  border-radius: 0;
}
.entity-edit::v-deep .v-input--selection-controls {
  margin: 10px;
}
</style>

